export default __webpack_public_path__ + "static/media/L3Harris_light.3a5e23f7.png";